// we should switch the name to page header, many pages are using this content
<template>
<div>
    <NavBar/>
    <div
      v-if="showPublicRideNoticeForManager"
      class="public-ride-manager-notice"
      role="alert"
      aria-live="polite">
      <div class="public-ride-manager-notice-inner">
        <span class="public-ride-manager-notice-icon" aria-hidden="true">&#9888;</span>
        <div class="public-ride-manager-notice-text">
          <span class="public-ride-manager-notice-critical">{{ t('publicRideManagerNoticeCritical') }}</span>
          <strong class="public-ride-manager-notice-title">{{ t('publicRideManagerNoticeTitle') }}</strong>
          <p class="public-ride-manager-notice-body">{{ t('publicRideManagerNoticeBody') }}</p>
        </div>
      </div>
    </div>
    <!-- Sticky Locked Badge - Visible when scrolling -->
    <div 
      v-if="isRideLocked && showStickyBadge && showLochedBadge" 
      class="ride-locked-badge-sticky"
      :title="t('rideIsLocked')"
      @click="rideHeader.ride && editRide(rideHeader.ride.id)">
      <span class="lock-icon">🔒</span>
      <span class="lock-text">{{ t('locked') }}</span>
    </div>

    <div  no-gutters 
          :style="compact ? {} : mainHeaderImageStyle"
          :class="['main_header_image', { 'main_header_compact': compact }]"
    >
      <!-- <NavBar/> -->
      <div
        v-if="presentedText=='RIDE_TITLE' && rideHeader.ride">
        <div class="container">
          <div
            v-if="presentedText=='RIDE_TITLE' && rideHeader.ride"
            class="trip-hero-content">
            <h1 v-if="!compact" class="trip-header-ride-title">
              {{rideHeader.ride.title}}
            </h1>
            <div
              class="centering_with_gap flex">
              <div 
                v-if="isRideLocked && showLochedBadge" 
                class="ride-locked-badge"
                :title="t('rideIsLocked')"
                @click="rideHeader.ride && editRide(rideHeader.ride.id)">
                <span class="lock-icon">🔒</span>
                <span class="lock-text">{{ t('locked') }}</span>
              </div>
              <a
                v-if="rideHeader.ride &&
                     !compareToUserId( rideHeader.ride.authorId ) &&
                     this.rideType=='public' &&
                     (!config.config.DEMO_RIDE_ID.includes(rideHeader.ride.id))"
                class="trip-edit-btn"
                @click="addRideToUser(rideHeader.ride.id)">
                <img 
                  :src="require('@/assets/images/editIcon.svg')"
                  width="23px"
                  height="23px"
                  alt=""
                  >
                {{ t('copyTripAndEdit') }}
              </a>
              <a
                v-else-if="rideHeader.ride && compareToUserId( rideHeader.ride.authorId )"
                class="trip-edit-btn"
                @click="editRide(rideHeader.ride.id)">
                <img 
                  :src="require('@/assets/images/editIcon.svg')"
                  alt=""
                  width="23px"
                  height="23px"
                  >
                {{ t('editTripDetails') }}
              </a>
              <a
                v-if="rideHeader.ride && compareToUserId( rideHeader.ride.authorId ) && rideHeader.ride.ride_manager_id==userId && this.rideType=='private'"
                class="trip-edit-btn"
                @click="copyPrivateRide(rideHeader.ride.id)">
                <img 
                  :src="require('@/assets/images/editIcon.svg')"
                  width="23px"
                  height="23px"
                  alt=""
                  >
                {{ t('duplicateTrip') }}
              </a>
              <template v-if="rideHeader.ride && compareToUserId( rideHeader.ride.authorId ) && rideHeader.ride.ride_manager_id==userId && this.rideType=='private'">
              <div v-if="showShareRideHint" class="share-ride-hint-wrap">
                <span class="share-ride-hint-bubble">{{ t('shareRideHintBubble') }}</span>
                <a
                  class="trip-edit-btn share-ride-hint-pulse"
                  @click="displayTheRideAcessKey(rideHeader.ride.id)">
                  {{ t('showRegistrationLink') }}
                </a>
              </div>
              <a
                v-else
                class="trip-edit-btn"
                @click="displayTheRideAcessKey(rideHeader.ride.id)">
                {{ t('showRegistrationLink') }}
              </a>
              </template>
              <!-- Reset Ride Button - Less prominent, only for copied rides -->
              <div v-if="rideHeader.ride && compareToUserId( rideHeader.ride.authorId ) && !rideHeader.ride.is_based_ride && rideHeader.ride.is_white_label && this.rideType=='private' && !isRideLocked" class="reset-ride-container">
                <ResetRideModal :ride-id="rideHeader.ride.id" />
              </div>

              <a
                v-if="this.rideType=='public' && (!config.config.DEMO_RIDE_ID.includes(rideHeader.ride.id ) )"
                class="trip-share-btn"
                @click="showModal( 'shareRide' )">
                <img
                  :src="require('@/assets/images/shereIcon.svg')"
                  alt=""
                  width="20px"
                  height="24px"
                  >
                {{ t('shareTrip') }}
              </a>
            </div>
          </div>
        </div>
        <!-- <div
          class="edit-mode-container"
          v-if="rideHeader.ride && compareToUserId( rideHeader.ride.authorId )">
                          <h2>{{ t('editMode') }}</h2>
        </div> -->
      </div>
      <div
      v-else-if="presentedText && presentedText!='RIDE_TITLE'"
      class="container" >
        <div class="trip-hero-content">
          <h1 class="trip-header-ride-title" > {{presentedText}}   </h1>
        </div>
      </div>
    </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { translationMixin } from "@/mixins/translationMixin";
import NavBar from "@/components/NavBar.vue";
import config from '@/common/config';
import ResetRideModal from '@/components/Modals/ResetRideModal.vue';


export default {
    name: 'SingleRideHeader',
    mixins: [translationMixin],
    props: ['presentedText',
            'shouldPresentLocation',
            // The ride page's poster design: the poster carries the title and
            // the photos, so this keeps only the buttons, on a plain strip.
            'compact'],
    data() {
      return {
        mainHeaderImageStyle: {
          background: `url('https://firebasestorage.googleapis.com/v0/b/tripplanner-308b3.appspot.com/o/gui_images%2Fhero-bg.jpg?alt=media&token=170e81d2-ae7e-46eb-b20a-75f0b49fe11d') no-repeat center center`,
        },
        showLochedBadge: false,
        showStickyBadge: false,
        scrollObserver: null,
      }
    },
    components: {
      NavBar,
      ResetRideModal
    },
    computed: { ...mapGetters([ 'userId',
                                'compareToUserId',
                                'rideHeader',
                                'isMobile',
                                'rideType',
                                'getResizeImageForMobileDevices',
                                'isRideLocked',
                                'showShareRideHint',
                                'isUserManager',
                                 ]),
      config() {
       return config;
      },
      showPublicRideNoticeForManager() {
        const r = this.rideHeader?.ride;
        if (!r || !this.isUserManager) {
          return false;
        }
        // Match store ride.js rideType, but use rideHeader.ride so we do not flash
        // "public" while state.ride is still empty or stale (header loads before full ride).
        const isPrivateRide = typeof r.ride_manager_id === 'number';
        if (isPrivateRide) {
          return false;
        }
        if (!this.compareToUserId(r.authorId)) {
          return false;
        }
        return true;
      },
    },
    created() {
      this.validateAndupdateAppToken();
      var resizedUrl = 'https://firebasestorage.googleapis.com/v0/b/tripplanner-308b3.appspot.com/o/gui_images%2Fhero-bg.jpg?alt=media&token=170e81d2-ae7e-46eb-b20a-75f0b49fe11d';
      
      // Check if we're on a featured rides page and use heroImage if available
      const featuredPageHero = this.getFeaturedPageHeroImage();
      if (featuredPageHero) {
        resizedUrl = featuredPageHero;
        this.mainHeaderImageStyle = { background: `url('${resizedUrl}') no-repeat center center`, 'background-size': 'cover', }
      }
      else if(this.rideHeader?.ride?.top_page_image_url){
        resizedUrl = this.rideHeader.ride.top_page_image_url
        this.mainHeaderImageStyle = { background: `url('${resizedUrl}') no-repeat center center`, 'background-size': 'cover', }
      }
      else if(this.isMobile){
        resizedUrl = 'https://firebasestorage.googleapis.com/v0/b/tripplanner-308b3.appspot.com/o/gui_images%2Fhero-bg_300x300.jpg?alt=media&token=9fdfdb38-6917-421e-a9c4-daa9449819c5';
        this.mainHeaderImageStyle = { background: `url('${resizedUrl}') no-repeat center center`, 'background-size': 'cover', }
      }
    },
    mounted() {
      // Check if ride is locked and user is author once data is available
      this.checkAndSetupLockedBadge();
    },
    beforeDestroy() {
      if (this.scrollObserver) {
        this.scrollObserver.disconnect();
      }
    },
    watch: {
      '$route': {
        handler() {
          // Update background when route changes (e.g., switching between featured rides pages)
          const featuredPageHero = this.getFeaturedPageHeroImage();
          if (featuredPageHero) {
            this.mainHeaderImageStyle = {
              background: `url('${featuredPageHero}') no-repeat center center`,
              'background-size': 'cover',
            };
          }
        },
        immediate: false
      },
      rideHeader(newval) {
        // Only use ride image if we're not on a featured rides page
        const featuredPageHero = this.getFeaturedPageHeroImage();
        if (!featuredPageHero && newval?.ride?.top_page_image_url) {
          (async () => {
            // const imageUrl = this.getResizeImageForMobileDevices(newval.ride.top_page_image_url);
            const imageUrl = newval.ride.top_page_image_url;
            this.mainHeaderImageStyle = {
              background: `url('${imageUrl}') no-repeat center center`,
              'background-size': 'cover',
            };
          })();
        }
        // Check if ride is locked and setup badge when rideHeader data arrives
        // This will also setup the scroll observer if needed
        this.checkAndSetupLockedBadge();
      },
      isRideLocked(newVal) {
        if (newVal) {
          // Check if user is author before setting up
          this.checkAndSetupLockedBadge();
          this.$nextTick(() => {
            this.setupScrollObserver();
          });
        } else {
          if (this.scrollObserver) {
            this.scrollObserver.disconnect();
            this.scrollObserver = null;
          }
          this.showStickyBadge = false;
          this.showLochedBadge = false;
        }
      }
    },
    methods: {
      ...mapActions([  'addRideToUser',
                      'copyPrivateRide',
                      'removeAttractionFromRide',
                      'validateAndupdateAppToken',
                      'openLoginForm',
                      'showModal',
                      'openRideInformationPage',
                     ]),
      getFeaturedPageHeroImage() {
        const routeName = this.$route?.name;
        const featuredPages = config.config.FEATURED_RIDES || [];

        if (!Array.isArray(featuredPages) || !routeName) {
          return null;
        }

        // Case 1: digital guide info page (by manager)
        if (routeName === 'digital-guide-info') {
          const managerUrlName = this.$route?.query?.manager || this.$route?.params?.managerUrlName || null;

          let selectedPage = null;
          if (managerUrlName) {
            selectedPage = featuredPages.find(page =>
              page.managerUrlName === managerUrlName ||
              page.slug === managerUrlName
            );
          }

          if (!selectedPage) {
            selectedPage = featuredPages.find(page => page.isDefault) || featuredPages[0];
          }

          return selectedPage?.heroImage || null;
        }

        // Case 2: featured rides landing pages (by manager)
        if (routeName === 'featured-rides-landing' || routeName === 'featured-rides-landing-manager') {
          const managerUrlName = this.$route?.params?.managerUrlName || null;

          let selectedPage = null;
          if (managerUrlName) {
            selectedPage = featuredPages.find(page =>
              page.managerUrlName === managerUrlName ||
              page.slug === managerUrlName
            );
          }

          if (!selectedPage) {
            selectedPage = featuredPages.find(page => page.isDefault) || featuredPages[0];
          }

          return selectedPage?.heroImage || null;
        }

        // Helper: find page that owns a given ride id/url
        const findOwningPageByRide = (routeIdParam, rideIdFromQuery) => {
          const routeId = routeIdParam || rideIdFromQuery;
          const numericId = routeId ? parseInt(routeId) : null;

          if (!routeId && !numericId) {
            return null;
          }

          return featuredPages.find(page => {
            if (!Array.isArray(page.rides)) {
              return false;
            }
            return page.rides.some(ride => {
              const rideIdMatch = numericId &&
                ride.rideId === numericId;
              const urlMatch = routeId &&
                ride.url === `/featured-ride-detail/${routeId}`;
              return rideIdMatch || urlMatch;
            });
          });
        };

        // Case 2: featured ride detail page – find the page that owns this ride
        if (routeName === 'featured-ride-detail') {
          const routeId = this.$route?.params?.id;
          const owningPage = findOwningPageByRide(routeId, null);

          return owningPage?.heroImage || null;
        }

        // Case 3: payment & payment-success pages – use rideId from query to find owning featured page
        if (routeName === 'payment' || routeName === 'payment-success') {
          const rideIdFromQuery = this.$route?.query?.rideId || null;
          const owningPage = findOwningPageByRide(null, rideIdFromQuery);

          return owningPage?.heroImage || null;
        }

        return null;
      },
      checkAndSetupLockedBadge() {
        // Only show locked badge if ride is locked AND user is the author
        if (this.isRideLocked && this.rideHeader?.ride && this.compareToUserId(this.rideHeader.ride.authorId)) {
          this.showLochedBadge = true;
          // Setup scroll observer when badge should be shown (needed after lock status update)
          this.$nextTick(() => {
            this.setupScrollObserver();
          });
        } else {
          this.showLochedBadge = false;
        }
      },
      setupScrollObserver() {
        if (this.scrollObserver) {
          this.scrollObserver.disconnect();
        }
        
        // Try to find header element, with retry if not found
        const headerElement = document.querySelector('.main_header_image');
        if (!headerElement) {
          // Retry after a short delay if element not found
          setTimeout(() => {
            this.setupScrollObserver();
          }, 100);
          return;
        }
        
        this.scrollObserver = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              // Show sticky badge when header is not visible (scrolled past)
              this.showStickyBadge = !entry.isIntersecting;
            });
          },
          {
            root: null,
            threshold: 0,
            rootMargin: '-50px 0px 0px 0px' // Trigger when header is 50px above viewport
          }
        );
        
        this.scrollObserver.observe(headerElement);
      },
      editRide( rideId ){
        this.openRideInformationPage( rideId );
      },
      displayTheRideAcessKey( rideId ){
        this.$store.commit('setShowShareRideHint', false);  
        this.$router.push('/ride_access_key_information/' + rideId);
      },
    }
  };
</script>

<style scoped>
.main_header_image {
    -webkit-background-size: cover;
    -moz-background-size: cover;
    -o-background-size: cover;
    background-size: cover;
    margin-top: 50px;
    min-height: 150px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
}

.reset-ride-container {
  position: absolute;
  bottom: 10px;
  left: 10px;
  opacity: 1; /* Make it fully visible instead of 0.7 */
  font-size: 1em; /* Increase from 0.85em */
  z-index: 10;
  background: rgba(220, 53, 69, 0.1); /* Add a subtle red background */
  padding: 5px 10px;
  border-radius: 8px;
  border: 1px solid rgba(220, 53, 69, 0.3);
}

.reset-ride-container:hover {
  opacity: 1;
  background: rgba(220, 53, 69, 0.2); /* Darker on hover */
  transform: scale(1.05); /* Slight grow effect on hover */
  transition: all 0.2s ease;
}

.ride-locked-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 10px 18px;
  background-color: rgba(255, 193, 7, 0.95);
  border: 2px solid #ffc107;
  border-radius: 12px;
  font-size: 1rem;
  color: #856404;
  font-weight: 700;
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.4);
  text-shadow: 0 1px 2px rgba(255, 255, 255, 0.6);
  backdrop-filter: blur(10px);
  position: relative;
  z-index: 10;
  transition: all 0.2s ease;
  white-space: nowrap;
  cursor: pointer;
}

.ride-locked-badge .lock-icon {
  font-size: 1.2rem;
  display: inline-block;
}

.ride-locked-badge .lock-text {
  display: inline-block;
}

.ride-locked-badge:hover {
  background-color: rgba(255, 193, 7, 1);
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.5);
  transform: scale(1.05);
}

/* Sticky locked badge - appears when scrolling */
.ride-locked-badge-sticky {
  position: fixed;
  top: 60px;
  left: 50%;
  transform: translateX(-50%);
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 10px 18px;
  background-color: rgba(255, 193, 7, 0.98);
  border: 2px solid #ffc107;
  border-radius: 12px;
  font-size: 1rem;
  color: #856404;
  font-weight: 700;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.5);
  text-shadow: 0 1px 2px rgba(255, 255, 255, 0.6);
  backdrop-filter: blur(10px);
  z-index: 1050;
  transition: all 0.3s ease;
  white-space: nowrap;
  animation: slideDown 0.3s ease;
  cursor: pointer;
}

.ride-locked-badge-sticky .lock-icon {
  font-size: 1.2rem;
  display: inline-block;
}

.ride-locked-badge-sticky .lock-text {
  display: inline-block;
}

.ride-locked-badge-sticky:hover {
  background-color: rgba(255, 193, 7, 1);
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.6);
  transform: translateX(-50%) scale(1.05);
}

@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateX(-50%) translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateX(-50%) translateY(0);
  }
}

/* Adjust for mobile */
@media (max-width: 768px) {
  .ride-locked-badge-sticky {
    top: 50px;
    padding: 8px 14px;
    font-size: 0.9rem;
  }
  
  .ride-locked-badge-sticky .lock-icon {
    font-size: 1rem;
  }
}

.share-ride-hint-wrap {
  position: relative;
  display: inline-block;
}

.share-ride-hint-bubble {
  position: absolute;
  bottom: 100%;
  left: 50%;
  transform: translateX(-50%) translateY(-8px);
  background: #0D2F29;
  color: #fff;
  padding: 8px 12px;
  border-radius: 10px;
  font-size: 14px;
  white-space: nowrap;
  box-shadow: 0 4px 12px rgba(0,0,0,0.15);
  z-index: 10;
  pointer-events: none;
}

.share-ride-hint-bubble::after {
  content: "";
  position: absolute;
  top: 100%;
  left: 50%;
  margin-left: -6px;
  border: 6px solid transparent;
  border-top-color: #0D2F29;
}

[dir="rtl"] .share-ride-hint-bubble {
  left: auto;
  right: 50%;
  transform: translateX(50%) translateY(-8px);
}

[dir="rtl"] .share-ride-hint-bubble::after {
  left: auto;
  right: 50%;
  margin-right: -6px;
  margin-left: 0;
}

.public-ride-manager-notice {
  margin-top: 50px;
  padding: 1.35rem 1.5rem;
  background: linear-gradient(
    180deg,
    #fff4d6 0%,
    #ffe8a8 100%
  );
  border: 2px solid #b8860b;
  border-inline-start-width: 6px;
  border-inline-start-color: #92400e;
  box-shadow:
    0 4px 14px rgba(146, 64, 14, 0.22),
    inset 0 1px 0 rgba(255, 255, 255, 0.65);
  position: relative;
  z-index: 1020;
}

.public-ride-manager-notice-inner {
  max-width: 1100px;
  margin: 0 auto;
  display: flex;
  align-items: flex-start;
  gap: 1.2rem;
}

.public-ride-manager-notice-icon {
  flex-shrink: 0;
  font-size: 3rem;
  line-height: 1;
  color: #92400e;
  filter: drop-shadow(0 1px 1px rgba(0, 0, 0, 0.12));
  margin-top: 0.1rem;
}

.public-ride-manager-notice-text {
  display: flex;
  flex-direction: column;
  gap: 0.65rem;
  color: #422006;
  text-align: inherit;
}

.public-ride-manager-notice-critical {
  display: inline-block;
  align-self: flex-start;
  font-size: 1rem;
  font-weight: 800;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: #fff;
  background: #92400e;
  padding: 0.32rem 0.75rem;
  border-radius: 6px;
  line-height: 1.2;
}

.public-ride-manager-notice-title {
  display: block;
  font-size: 1.65rem;
  font-weight: 800;
  line-height: 1.32;
  color: #451a03;
}

.public-ride-manager-notice-body {
  margin: 0;
  font-size: 1.35rem;
  font-weight: 600;
  line-height: 1.55;
  color: #78350f;
}

@media (min-width: 992px) {
  .public-ride-manager-notice-icon {
    font-size: 3.35rem;
  }
  .public-ride-manager-notice-critical {
    font-size: 1.05rem;
    padding: 0.35rem 0.8rem;
  }
  .public-ride-manager-notice-title {
    font-size: 1.85rem;
    line-height: 1.28;
  }
  .public-ride-manager-notice-body {
    font-size: 1.45rem;
  }
}

@media (max-width: 768px) {
  .public-ride-manager-notice {
    padding: 1.15rem 1.15rem;
  }
  .public-ride-manager-notice-inner {
    gap: 0.95rem;
  }
  .public-ride-manager-notice-icon {
    font-size: 2.45rem;
  }
  .public-ride-manager-notice-critical {
    font-size: 0.92rem;
    padding: 0.28rem 0.6rem;
  }
  .public-ride-manager-notice-title {
    font-size: 1.35rem;
  }
  .public-ride-manager-notice-body {
    font-size: 1.18rem;
  }
}

/* Avoid doubling navbar offset when the public-ride notice is shown above the hero */
/* No header photo (the poster design): a light bar, not the brand colour --
   the buttons below are the brand colour themselves and would vanish on it. */
.main_header_compact {
    background: #fff;
    border-bottom: 1px solid #ececef;
    min-height: 0;
    padding: 12px 0 0;
}

.main_header_compact .trip-hero-content .centering_with_gap {
    margin-bottom: 12px;
}

/* The header's buttons, in every design: pills, one line each, so three of
   them fit a phone in one or two rows. */
.main_header_image .trip-hero-content .centering_with_gap {
    flex-wrap: wrap;
    justify-content: center;
    gap: 8px;
}

.main_header_image a.trip-edit-btn,
.main_header_image a.trip-share-btn {
    padding: 8px 14px;
    border-radius: 999px;
    font-size: 14px;
    white-space: nowrap;
    box-shadow: 0 4px 12px -6px rgba(0, 0, 0, 0.35);
}

.main_header_image a.trip-edit-btn img,
.main_header_image a.trip-share-btn img {
    height: 16px;
    width: auto;
}

.public-ride-manager-notice ~ .main_header_image {
  margin-top: 0;
}

.share-ride-hint-pulse {
  animation: share-ride-pulse 1.5s ease-in-out infinite;
}

@keyframes share-ride-pulse {
  0%, 100% { box-shadow: 0 0 0 0 rgba(7, 160, 195, 0.5); }
  50% { box-shadow: 0 0 0 10px rgba(7, 160, 195, 0); }
}

</style>
